import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=551274d1"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('551274d1')) {
      api.createRecord('551274d1', component.options)
    } else {
      api.reload('551274d1', component.options)
    }
    module.hot.accept("./Bar.vue?vue&type=template&id=551274d1", function () {
      api.rerender('551274d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Graphics/Bar.vue"
export default component.exports